import getTrainingTimePreferencesSelect from '../get-training-time'
import { setHoursMinutesAndSecondsDateUtil } from 'packages/src'
import { createSelector } from 'reselect'

const getTrainingTimeDatePreferencesSelect = createSelector(getTrainingTimePreferencesSelect,
  (trainingTimeStr) => {
    let hours
    let minutes
    if (typeof trainingTimeStr === 'string') {
      [
        hours,
        minutes
      ] = trainingTimeStr.split(':')
    } else {
      hours = trainingTimeStr
      minutes = 0
    }
    return setHoursMinutesAndSecondsDateUtil(new Date(), {
      hours,
      minutes,
      second: 0,
      millisecond: 0
    })
  }
)

export default getTrainingTimeDatePreferencesSelect
